<template>
  <div class="mainbody">
    <div id="app" v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>首页</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-box">
        <el-row :gutter="36">
          <el-col :span="24" :xs="24">
            <el-row :gutter="36">
              <el-col :span="24">
                <el-card>
                  <div
                    style="
                      text-align: left;
                      padding-bottom: 20px;
                      font-weight: 600;
                    "
                  >
                    累计数据
                  </div>
                  <!--统计信息-->
                  <el-row
                    :gutter="24"
                    class="count-box"
                    v-if="fx_login_companyType != 0"
                  >
                    <el-col class="bg_4994c4" :span="el_col_span">
                      <el-card>
                        <h1>
                          <VueCountUp
                            :star-value="0"
                            :end-value="summaryData.chargeCountToday || 0"
                            :duration="2"
                            :decimals="1"
                          ></VueCountUp>
                        </h1>
                        <p>日充电量（KW.h）</p>
                      </el-card>
                    </el-col>
                    <el-col class="bg_4994c4" :span="el_col_span">
                      <el-card>
                        <h1>
                          <VueCountUp
                            :star-value="0"
                            :end-value="summaryData.dischargeCountToday || 0"
                            :duration="2"
                            :decimals="1"
                          ></VueCountUp>
                        </h1>
                        <p>日放电量（KW.h）</p>
                      </el-card>
                    </el-col>
                    <el-col class="bg_6f94cd" :span="el_col_span">
                      <el-card>
                        <h1>
                          <VueCountUp
                            :star-value="0"
                            :end-value="summaryData.chargeCountMonth || 0"
                            :duration="2"
                            :decimals="1"
                          ></VueCountUp>
                        </h1>
                        <p>月充电量（KW.h）</p>
                      </el-card>
                    </el-col>
                    <el-col class="bg_6f94cd" :span="el_col_span">
                      <el-card>
                        <h1>
                          <VueCountUp
                            :star-value="0"
                            :end-value="summaryData.dischargeCountMonth || 0"
                            :duration="2"
                            :decimals="1"
                          ></VueCountUp>
                        </h1>
                        <p>月放电量（KW.h）</p>
                      </el-card>
                    </el-col>
                  </el-row>
                  <!-- <el-row :gutter="24" class="count-box"  v-if="fx_login_companyType != 0">
                                        <el-col class="bg_3271ae" :span="el_col_span">
                                            <el-card >
                                                <h1><VueCountUp :star-value="0" :end-value="summaryData.cabinetCount || 0" :duration="2" :decimals="0"></VueCountUp></h1>
                                                <p>设备数量(台)</p>
                                            </el-card>
                                        </el-col>
                                    </el-row> -->
                  <el-row
                    :gutter="24"
                    class="count-box"
                    v-if="fx_login_companyType == 0"
                  >
                    <el-col class="bg_3271ae" :span="el_col_span">
                      <el-card>
                        <h1>
                          <VueCountUp
                            :star-value="0"
                            :end-value="summaryData.companyCount || 0"
                            :duration="2"
                            :decimals="0"
                          ></VueCountUp>
                        </h1>
                        <p>客户数量(个)</p>
                      </el-card>
                    </el-col>
                    <el-col class="bg_4994c4" :span="el_col_span">
                      <el-card>
                        <h1>
                          <VueCountUp
                            :star-value="0"
                            :end-value="summaryData.chargeCountToday || 0"
                            :duration="2"
                            :decimals="1"
                          ></VueCountUp>
                          /
                          <VueCountUp
                            :star-value="0"
                            :end-value="summaryData.dischargeCountToday || 0"
                            :duration="2"
                            :decimals="1"
                          ></VueCountUp>
                        </h1>
                        <p>日充/放电量（KW.h）</p>
                      </el-card>
                    </el-col>
                    <el-col class="bg_6f94cd" :span="el_col_span">
                      <el-card>
                        <h1>
                          <VueCountUp
                            :star-value="0"
                            :end-value="summaryData.chargeCountMonth || 0"
                            :duration="2"
                            :decimals="1"
                          ></VueCountUp>
                          /
                          <VueCountUp
                            :star-value="0"
                            :end-value="summaryData.dischargeCountMonth || 0"
                            :duration="2"
                            :decimals="1"
                          ></VueCountUp>
                        </h1>
                        <p>月充/放电量（KW.h）</p>
                      </el-card>
                    </el-col>
                    <el-col class="bg_3271ae" :span="el_col_span">
                      <el-card>
                        <h1>
                          <VueCountUp
                            :star-value="0"
                            :end-value="summaryData.cabinetCount || 0"
                            :duration="2"
                            :decimals="0"
                          ></VueCountUp>
                        </h1>
                        <p>设备数量(台)</p>
                      </el-card>
                    </el-col>
                  </el-row>
                  <el-row
                    :gutter="24"
                    class="count-box"
                    v-if="fx_login_companyType == 0"
                  >
                    <el-col class="bg_2e59a7" :span="el_col_span">
                      <el-card>
                        <h1>
                          <VueCountUp
                            :star-value="0"
                            :end-value="
                              summaryData.cabinetCountMalfunction || 0
                            "
                            :duration="2"
                          ></VueCountUp>
                          /
                          <VueCountUp
                            :star-value="0"
                            :end-value="summaryData.cabinetCountOperation || 0"
                            :duration="2"
                          ></VueCountUp>
                        </h1>
                        <p>故障/运行设备</p>
                      </el-card>
                    </el-col>
                    <el-col class="bg_3271ae" :span="el_col_span">
                      <el-card>
                        <h1>
                          {{ summaryData.maxCabinetCodeToday || 0 }} /
                          <VueCountUp
                            :star-value="0"
                            :end-value="summaryData.maxEarningsToday || 0"
                            :duration="2"
                            :decimals="2"
                          ></VueCountUp>
                        </h1>
                        <p>日最高收益设备/收益（元）</p>
                      </el-card>
                    </el-col>
                    <el-col class="bg_4994c4" :span="el_col_span">
                      <el-card>
                        <h1>
                          {{ summaryData.maxCabinetCodeMonth || 0 }} /
                          <VueCountUp
                            :star-value="0"
                            :end-value="summaryData.maxEarningsMonth || 0"
                            :duration="2"
                            :decimals="2"
                          ></VueCountUp>
                        </h1>
                        <p>月最高收益设备/收益（元）</p>
                      </el-card>
                    </el-col>
                    <el-col class="bg_6f94cd" :span="el_col_span">
                      <el-card>
                        <h1>
                          <VueCountUp
                            :star-value="0"
                            :end-value="summaryData.chargeCountMonthAvg || 0"
                            :duration="2"
                            :decimals="1"
                          ></VueCountUp>
                          /
                          <VueCountUp
                            :star-value="0"
                            :end-value="summaryData.dischargeCountMonthAvg || 0"
                            :duration="2"
                            :decimals="1"
                          ></VueCountUp>
                        </h1>
                        <p>月平均充/放电量（KW.h）</p>
                      </el-card>
                    </el-col>
                  </el-row>
                  <!--/统计信息-->
                </el-card>
              </el-col>

              <el-col :span="24" class="mab-20">
                <el-card>
                  <div
                    style="
                      text-align: left;
                      padding-bottom: 20px;
                      font-weight: 600;
                    "
                  >
                    数据趋势
                  </div>
                  <div class="chage_day_month">
                    <el-select
                      v-model="company"
                      :disabled="fx_login_companyType == 1"
                      @change="chageCompany"
                      filterable
                      placeholder="请选择公司"
                    >
                      <el-option value="" label="全部公司"></el-option>
                      <el-option
                        v-for="item in companyList"
                        :key="item.id"
                        :label="item.companyName"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                    <el-select
                      v-model="device"
                      filterable
                      placeholder="请选择设备"
                    >
                      <el-option
                        v-for="item in deviceList"
                        :key="item.cabinetCode"
                        :label="
                          item.cabinetCode + ' ( ' + item.cabinetName + ' ) '
                        "
                        :value="item.cabinetCode"
                      >
                      </el-option>
                    </el-select>
                    <el-date-picker
                      v-show="dayMouth"
                      v-model="firstDay"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      :picker-options="pickerOptions"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>

                    <el-date-picker
                      v-show="!dayMouth"
                      v-model="lastMonth"
                      type="monthrange"
                      range-separator="至"
                      start-placeholder="开始月份"
                      end-placeholder="结束月份"
                      :picker-options="pickerOptions"
                      format="yyyy-MM"
                      value-format="yyyy-MM"
                    >
                    </el-date-picker>
                    <span
                      class="day_month_span day_month_span_click"
                      @click="chageDayMou"
                      >日月统计切换</span
                    >
                    <span
                      class="day_month_span day_month_span_serch"
                      @click="dayMonthSerch"
                      >搜索</span
                    >
                  </div>
                </el-card>
                <el-card v-show="dayMouth">
                  <div class="ibtn-box">
                    <div
                      id="dailyChart"
                      style="height: 382px; margin-top: 20px"
                    ></div>
                  </div>
                </el-card>
                <el-card v-show="!dayMouth">
                  <div class="ibtn-box">
                    <div
                      id="monthlyChart"
                      style="height: 382px; margin-top: 20px"
                    ></div>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </el-col>

          <el-col :span="8" :xs="24">
            <el-row>
              <el-col :span="24" class="mab-20">
                <el-card v-show="false">
                  <div slot="header" class="clearfix">
                    <i class="el-icon-monitor"></i>
                    <span>数据信息</span>
                  </div>
                  <div class="cinfo-box">
                    <div class="dl-box clearfix">
                      <dl>
                        <dt></dt>
                        <dd>{{ config.webName }}</dd>
                      </dl>
                      <dl>
                        <dt></dt>
                        <dd>{{ config.webUrl }}</dd>
                      </dl>
                      <dl>
                        <dt></dt>
                        <dd>{{ config.webCompany }}</dd>
                      </dl>
                      <dl>
                        <dt></dt>
                        <dd>{{ config.webVersion }}</dd>
                      </dl>
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts"; //eslint-disable-line no-unused-vars
// import "echarts/map/js/china"; // 引入中国地图数据
import {
  AxiosAjax,
  addDate,
  addMonth,
  saveModelData,
} from "../../js/axios.config";
import VueCountUp from "vue-countupjs";
export default {
  components: {
    VueCountUp,
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      dayMouth: true, // 日月统计切换
      fx_login_companyType: 0,
      isShow: false,
      el_col_span: 6,
      disabled: false,
      loading: false,
      echartList: [],
      summaryData: {
        cabinetCount: 0,
        chargeCount: 0,
        companyCount: 0,
        dischargeCount: 0,
      },
      // alarmList: null, //报警列表  暂时去掉
      dailyData: [], //日统计
      monthlyData: [], //月统计
      config: [],

      firstDay: "",
      lastDay: "",
      firstMonth: "",
      lastMonth: "",
      company: "",
      companyList: [],
      device: "",
      deviceList: [],
    };
  },
  mounted() {
    //获取公司
    const _this = this;

    _this.fx_login_companyType = localStorage.getItem("fx_login_companyType");
    if (_this.fx_login_companyType != 0) {
      _this.company = localStorage.getItem("fx_login_companyId");
      _this.companyList = [
        {
          id: _this.company,
          companyName: localStorage.getItem("fx_login_company"),
        },
      ];
    } else {
      _this.company = "";
      AxiosAjax({
        url: "/cabinet/company/search",
        success: function (res) {
          _this.companyList = res.data.data;
        },
      });
    }
    _this.chageCompany();
  },
  methods: {
    chageCompany() {
      const _this = this;
      // 获取公司设备
      AxiosAjax({
        url: "/cabinet/cabinet/search?companyId=" + _this.company,
        success: function (res) {
          _this.deviceList = res.data.data;
        },
      });
    },
    dayMonthSerch() {
      // 搜索
      const _this = this;
      let sendUrl = "";
      var _dateFrom = addDate(new Date(), -12);
      var _dateTo = addDate(new Date(), 0);
      if (_this.dayMouth) {
        sendUrl = "/cabinet/home/dailyStats/v2?companyId=" + _this.company;
        if (_this.device) {
          sendUrl += "&cabinetCode=" + _this.device;
        }
        if (_this.firstDay) {
          sendUrl += "&dateFrom=" + _this.firstDay.toString().split(",")[0];
          sendUrl += "&dateTo=" + _this.firstDay.toString().split(",")[1];
        } else {
          sendUrl += "&dateFrom=" + _dateFrom;
          sendUrl += "&dateTo=" + _dateTo;
        }
      } else {
        _dateFrom = addMonth(new Date(), -5);
        _dateTo = addMonth(new Date(), 0);
        sendUrl = "/cabinet/home/monthlyStats/v2?companyId=" + _this.company;
        if (_this.device) {
          sendUrl += "&cabinetCode=" + _this.device;
        }
        if (_this.lastMonth) {
          sendUrl +=
            "&dateFrom=" + _this.lastMonth.toString().split(",")[0] || null;
          sendUrl +=
            "&dateTo=" + _this.lastMonth.toString().split(",")[1] || null;
        } else {
          sendUrl += "&dateFrom=" + _dateFrom;
          sendUrl += "&dateTo=" + _dateTo;
        }
      }
      AxiosAjax({
        url: sendUrl,
        success: function (res) {
          if (_this.dayMouth) {
            _this.dailyData = res.data.data;
          } else {
            _this.monthlyData = res.data.data;
          }
          _this.initChart();
        },
      });
    },
    chageDayMou() {
      this.dayMouth = !this.dayMouth;
      this.initChart();
    },
    //初始化图表
    initChart() {
      //处理数据
      let titleDaily = [];
      let titleMonthly = [];

      let dataChargePower = []; //充
      let dataDischargePower = []; //放
      let dataExpenditure = []; //
      let dataIncome = []; //
      let dataProfit = []; //

      this.dailyData.map((item) => {
        titleDaily.push(item.date);
        dataChargePower.push(item.chargePower);
        dataDischargePower.push(item.dischargePower);
        dataExpenditure.push(item.expenditure);
        dataIncome.push(item.income);
        dataProfit.push(item.profit);
      });

      //基于准备好的dom，初始化echarts实例
      let dailyChart = echarts.init(document.getElementById("dailyChart"));
      let monthlyChart = echarts.init(document.getElementById("monthlyChart"));
      this.$nextTick(() => {
        dailyChart.resize();
        monthlyChart.resize();
      });
      this.echartList.push(dailyChart);
      this.echartList.push(monthlyChart);

      var optionDaily = {
        color: ["#3398DB"],
        title: {
          text: "日统计数据(KW.h)",
          subtext: "",
          textStyle: { fontSize: 16, fontWeight: "normal", color: "#000" },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // type: 'shadow'
            type: "cross",
          },
        },
        grid: {
          left: "2%",
          right: "2%",
          bottom: "5%",
          width: "auto",
          height: "auto",
          containLabel: true,
        },
        axisLabel: {
          color: "#267cb7",
        },
        xAxis: {
          data: titleDaily,
          axisLine: {
            lineStyle: {
              color: "#267cb7",
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
          axisPointer: {
            snap: true,
          },
        },
        yAxis: {
          splitArea: {
            show: true,
          },
          axisLine: {
            lineStyle: {
              color: "#267cb7",
            },
          },
          type: "value",
        },
        series: [
          {
            name: "充电",
            type: "line",
            data: dataChargePower,
            itemStyle: {
              normal: {
                color: "#00aa00", //改变折线点的颜色
                lineStyle: {
                  color: "#00aa00", //改变折线颜色
                },
              },
            },
          },
          {
            name: "放电",
            type: "line",
            data: dataDischargePower,
            itemStyle: {
              normal: {
                color: "#0055ff", //改变折线点的颜色
                lineStyle: {
                  color: "#0055ff", //改变折线颜色
                },
              },
            },
          },
          {
            name: "成本",
            type: "line",
            data: dataExpenditure,
            itemStyle: {
              normal: {
                color: "#5555ff", //改变折线点的颜色
                lineStyle: {
                  color: "#5555ff", //改变折线颜色
                },
              },
            },
          },
          {
            name: "收入",
            type: "line",
            data: dataIncome,
            itemStyle: {
              normal: {
                color: "#555500", //改变折线点的颜色
                lineStyle: {
                  color: "#555500", //改变折线颜色
                },
              },
            },
          },
          {
            name: "利润",
            type: "line",
            data: dataProfit,
            itemStyle: {
              normal: {
                color: "#ff0000", //改变折线点的颜色
                lineStyle: {
                  color: "#ff0000", //改变折线颜色
                },
              },
            },
          },
        ],
      };

      var optionDailyCustomer = {
        color: ["#3398DB"],
        title: {
          text: "日统计数据(KW.h)",
          subtext: "",
          textStyle: { fontSize: 16, fontWeight: "normal", color: "#000" },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        grid: {
          left: "2%",
          right: "2%",
          bottom: "5%",
          width: "auto",
          height: "auto",
          containLabel: true,
        },
        axisLabel: {
          color: "#267cb7",
        },
        xAxis: {
          data: titleDaily,
          axisLine: {
            lineStyle: {
              color: "#267cb7",
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          splitArea: {
            show: true,
          },
          axisLine: {
            lineStyle: {
              color: "#267cb7",
            },
          },
          type: "value",
        },
        series: [
          {
            name: "充电",
            type: "line",
            data: dataChargePower,
            itemStyle: {
              normal: {
                color: "#00aa00", //改变折线点的颜色
                lineStyle: {
                  color: "#00aa00", //改变折线颜色
                },
              },
            },
          },
          {
            name: "放电",
            type: "line",
            data: dataDischargePower,
            itemStyle: {
              normal: {
                color: "#0055ff", //改变折线点的颜色
                lineStyle: {
                  color: "#0055ff", //改变折线颜色
                },
              },
            },
          },
        ],
      };

      if (this.isShow) {
        //绘制图表
        dailyChart.setOption(optionDaily);
      } else {
        //绘制图表
        dailyChart.setOption(optionDailyCustomer);
      }

      dataChargePower = []; //充
      dataDischargePower = []; //放
      dataExpenditure = []; //
      dataIncome = []; //
      dataProfit = []; //

      this.monthlyData.map((item) => {
        titleMonthly.push(item.date);
        dataChargePower.push(item.chargePower);
        dataDischargePower.push(item.dischargePower);
        dataExpenditure.push(item.expenditure);
        dataIncome.push(item.income);
        dataProfit.push(item.profit);
      });

      var optionMonthly = {
        color: ["#3398DB"],
        title: {
          text: "月统计数据(KW.h)",
          subtext: "",
          textStyle: { fontSize: 16, fontWeight: "normal", color: "#000" },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        grid: {
          left: "2%",
          right: "2%",
          bottom: "5%",
          width: "auto",
          height: "auto",
          containLabel: true,
        },
        xAxis: {
          data: titleMonthly,
          axisLine: {
            lineStyle: {
              color: "#267cb7",
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          splitArea: {
            show: true,
          },
          axisLine: {
            lineStyle: {
              color: "#267cb7",
            },
          },
          type: "value",
        },
        series: [
          {
            name: "充电",
            type: "line",
            data: dataChargePower,
            itemStyle: {
              normal: {
                color: "#00aa00", //改变折线点的颜色
                lineStyle: {
                  color: "#00aa00", //改变折线颜色
                },
              },
            },
          },
          {
            name: "放电",
            type: "line",
            data: dataDischargePower,
            itemStyle: {
              normal: {
                color: "#0055ff", //改变折线点的颜色
                lineStyle: {
                  color: "#0055ff", //改变折线颜色
                },
              },
            },
          },
          {
            name: "成本",
            type: "line",
            data: dataExpenditure,
            itemStyle: {
              normal: {
                color: "#5555ff", //改变折线点的颜色
                lineStyle: {
                  color: "#5555ff", //改变折线颜色
                },
              },
            },
          },
          {
            name: "收入",
            type: "line",
            data: dataIncome,
            itemStyle: {
              normal: {
                color: "#555500", //改变折线点的颜色
                lineStyle: {
                  color: "#555500", //改变折线颜色
                },
              },
            },
          },
          {
            name: "利润",
            type: "line",
            data: dataProfit,
            itemStyle: {
              normal: {
                color: "#ff0000", //改变折线点的颜色
                lineStyle: {
                  color: "#ff0000", //改变折线颜色
                },
              },
            },
          },
        ],
      };

      var optionMonthlyCustomer = {
        color: ["#3398DB"],
        title: {
          text: "月统计数据(KW.h)",
          subtext: "",
          textStyle: { fontSize: 16, fontWeight: "normal", color: "#000" },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        grid: {
          left: "2%",
          right: "2%",
          bottom: "5%",
          width: "auto",
          height: "auto",
          containLabel: true,
        },
        xAxis: {
          data: titleMonthly,
          axisLine: {
            lineStyle: {
              color: "#267cb7",
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          splitArea: {
            show: true,
          },
          axisLine: {
            lineStyle: {
              color: "#267cb7",
            },
          },
          type: "value",
        },
        series: [
          {
            name: "充电",
            type: "line",
            data: dataChargePower,
            itemStyle: {
              normal: {
                color: "#00aa00", //改变折线点的颜色
                lineStyle: {
                  color: "#00aa00", //改变折线颜色
                },
              },
            },
          },
          {
            name: "放电",
            type: "line",
            data: dataDischargePower,
            itemStyle: {
              normal: {
                color: "#0055ff", //改变折线点的颜色
                lineStyle: {
                  color: "#0055ff", //改变折线颜色
                },
              },
            },
          },
        ],
      };

      if (this.isShow) {
        //绘制图表
        monthlyChart.setOption(optionMonthly);
      } else {
        //绘制图表
        monthlyChart.setOption(optionMonthlyCustomer);
      }
    },
    // powerPlant() {
    //   AxiosAjax({
    //     url: "/getToken",
    //     method: "post",
    //     headers: {
    //       Authorization: {
    //         appId: "5T6U3BU78COS897",
    //         sign: "0fa872910e442a719e4a02d9140c7135e3eeebaf3efe2eb8f3e6ab8945722d8e",
    //       },
    //     },
    //     success: function (res) {
    //       if (res.data.code == 200) {
    //         localStorage.setItem(
    //           "fx_virtual_power_plant_token",
    //           res.data.data.token
    //         );
    //       }
    //     },
    //   });
    // },
  },
  created: function () {
    let _this = this;
    if (window.localStorage.getItem("fx_login_companyType") == "0") {
      _this.disabled = true;
      _this.el_col_span = 6;
      _this.isShow = true;
    } else {
      _this.el_col_span = 6;
    }
    //概要
    AxiosAjax({
      // /cabinet/home/summary/v2
      url: "/cabinet/home/summary/v2",
      success: function (res) {
        _this.summaryData = res.data.data || {
          cabinetCount: 0,
          chargeCount: 0,
          companyCount: 0,
          dischargeCount: 0,
        };
      },
    });

    var _dateFrom = addDate(new Date(), -12);
    var _dateTo = addDate(new Date(), 0);

    //日统计
    AxiosAjax({
      url:
        "/cabinet/home/dailyStats?dateFrom=" + _dateFrom + "&dateTo=" + _dateTo,
      success: function (res) {
        _this.dailyData = res.data.data;
        _this.initChart();
      },
    });

    _dateFrom = addMonth(new Date(), -5);
    _dateTo = addMonth(new Date(), 0);

    //月统计
    AxiosAjax({
      url:
        "/cabinet/home/monthlyStats?dateFrom=" +
        _dateFrom +
        "&dateTo=" +
        _dateTo,
      success: function (res) {
        _this.monthlyData = res.data.data;
        _this.initChart();
      },
    });
    //加载型号列表
    AxiosAjax({
      url: "/cabinet/model/search?index=1&size=9000&",
      loading: true,
      success: function (res) {
        saveModelData(res.data.data);
      },
    });
  },
};
</script>
<style scoped>
.chage_day_month {
  text-align: left;
}
.day_month_span {
  background: #267cb7;
  color: #fff;
  display: inline-block;
  height: 38px;
  line-height: 38px;
  margin-right: -6px;
  padding: 0 10px;
}
.day_month_span_click {
  cursor: pointer;
}
.day_month_span_serch {
  cursor: pointer;
  margin-left: 16px;
}
.card_line .el-card {
  background: linear-gradient(
    176deg,
    rgba(243, 244, 252, 0.45),
    rgba(22, 23, 85, 0.45)
  );
}
.count-box .el-card__body p {
  padding: 0;
}
.count-box .el-card__body h1 {
  padding: 0;
}
.bg_2e59a7 .el-card {
  background: url(../../assets/card_1.png);
  background-size: 100% 100%;
  border-radius: 8px;
}
.bg_3271ae .el-card {
  background: url(../../assets/card_2.png);
  background-size: 100% 100%;
  border-radius: 8px;
}
.bg_4994c4 .el-card {
  background: url(../../assets/card_3.png);
  background-size: 100% 100%;
  border-radius: 8px;
}
.bg_6f94cd .el-card {
  background: url(../../assets/card_4.png);
  background-size: 100% 100%;
  border-radius: 8px;
}
.count-box .el-card__body h1,
.count-box .el-card__body p,
.count-box .el-card__body h1 span {
  color: #fff;
}
.count-box .el-card__body p {
  padding: 5px 0;
  font-size: 14px;
}
.count-box .el-card__body h1 {
  font-size: 26px;
  margin: 6px 0;
}
.count-box .el-card__body h1 span {
  font-size: 26px;
}
/deep/ .count-box .el-card .el-card__body {
  padding: 10px 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Center.vue